import { Box, Grid, Image, Text } from "@mantine/core";
import useStyles from "./style";
const InovationSection = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.InlinePadding}>
      <Box className={classes.innovationSection}>
        <Grid gutter={0} sx={{ zIndex: 10, position: "relative" }}>
          <Grid.Col span={10} md={5}>
            <Image src="/assets/images/innovationSecImg.png" width='95%' />
          </Grid.Col>
          <Grid.Col span={12} md={7}>
            <Text className="heading">Innovation at Your Fingertips</Text>
            <Text className="description">
              Stay ahead of the curve with Ogiso's continuous innovation. We are
              committed to providing you with the latest features and updates to
              keep your facility running smoothly. Our platform evolves with the
              ever-changing landscape of state regulation and technology,
              ensuring that you always have the best tools at your disposal
            </Text>
          </Grid.Col>
        </Grid>
        <Image
          src="/assets/images/overviewSecLeftImg.png"
          width={245}
          className="boxesImg"
        />
      </Box>
    </Box>
  );
};

export default InovationSection;
